import { useCachedQueryInfinite } from '@packages/shared/core/queryCache/hooks';
import { QueryCacheInfiniteProviderOptions } from '@packages/shared/core/queryCache/entities';
import { DynamicReviewsKey, ExpertReview, ReviewsGetKey } from '../entities';

type UseAllReviewsQueryParams = {
  getKey: ReviewsGetKey;
  options?: QueryCacheInfiniteProviderOptions<Array<ExpertReview>, { message: string }>;
};

export const useAllReviewsQuery = ({ getKey, options }: UseAllReviewsQueryParams) => {
  const { data, isLoading, isValidating, error, size, setSize } = useCachedQueryInfinite<
    Array<ExpertReview>,
    DynamicReviewsKey
  >(
    getKey,
    ({ services }) =>
      (key) => {
        const { expertService } = services;
        const { page, perPage, minRating, minTextLength, sort } = key;
        return expertService.getAllReviews({
          page,
          perPage,
          minRating,
          minTextLength,
          sort,
        });
      },
    options,
  );

  return {
    reviews: data,
    areReviewsLoading: isLoading || isValidating,
    errorLoadingReviews: error?.message || '',
    size,
    setSize,
  };
};
